module.exports = __webpack_public_path__ + "static/media/ReferenceGroup.9ae4893f.svg";